module.exports = __webpack_public_path__ + "static/media/1.2e265b55.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/悬浮窗/1.png
// module id = 978
// module chunks = 0